(function () {
  'use strict';

  var lifecycleKey = typeof Symbol === 'function' && Symbol.for
    ? Symbol.for('rwady.account.page.lifecycle')
    : '__rwadyAccountPageLifecycle__';
  var previousLifecycle = window[lifecycleKey];
  if (previousLifecycle && typeof previousLifecycle.destroy === 'function') previousLifecycle.destroy();
  var activeController = null;

  function initializeAccount(root) {
  if (!root || root.dataset.initialized === 'true' || !window.RwadyAccountApi || !window.RwadyAvatar) return null;
  root.dataset.initialized = 'true';
  var disposed = false;

  var labelsNode = root.querySelector('[data-rwady-account-labels]');
  var labels = {};
  try { labels = JSON.parse(labelsNode.textContent || '{}'); } catch (error) { labels = {}; }
  var api = window.RwadyAccountApi.createClient({ baseUrl: root.dataset.apiBase });
  var isRtl = root.dataset.isRtl === 'true';
  var loading = root.querySelector('[data-account-loading]');
  var errorBox = root.querySelector('[data-account-error]');
  var auth = root.querySelector('[data-account-auth]');
  var app = root.querySelector('[data-account-app]');
  var authStatus = root.querySelector('[data-auth-status]');
  var phoneForm = root.querySelector('[data-auth-phone-form]');
  var codeForm = root.querySelector('[data-auth-code-form]');
  var resendButton = root.querySelector('[data-auth-resend]');
  var profileStatus = root.querySelector('[data-profile-status]');
  var profileFormStatus = root.querySelector('[data-profile-form-status]');
  var profileDialog = root.querySelector('[data-profile-dialog]');
  var profileForm = root.querySelector('[data-profile-form]');
  var addressStatus = root.querySelector('[data-address-status]');
  var addressFormStatus = root.querySelector('[data-address-form-status]');
  var addressDialog = root.querySelector('[data-address-dialog]');
  var addressForm = root.querySelector('[data-address-form]');
  var avatarStatus = root.querySelector('[data-avatar-status]');
  var avatarInput = root.querySelector('[data-avatar-input]');
  var avatarDialog = root.querySelector('[data-avatar-dialog]');
  var avatarCanvas = root.querySelector('[data-avatar-canvas]');
  var avatarZoom = root.querySelector('[data-avatar-zoom]');
  var avatarSave = root.querySelector('[data-avatar-crop-save]');
  var avatarDialogStatus = root.querySelector('[data-avatar-dialog-status]');
  var deletionDialog = root.querySelector('[data-account-deletion-dialog]');
  var deletionForm = root.querySelector('[data-account-deletion-form]');
  var deletionStatus = root.querySelector('[data-account-deletion-status]');
  var accountLoadPromise = null;
  var accountRefresh = null;
  var state = {
    profile: null,
    addresses: [],
    challengeId: '',
    phone: '',
    fullName: '',
    authMode: 'login',
    authSending: false,
    resendAt: 0,
    resendTimer: 0,
    createAttempt: null,
    avatarFile: null,
    avatarImage: null,
    avatarCrop: { zoom: 1, offsetX: 0, offsetY: 0 },
    avatarPointer: null,
    deletionChallengeId: '',
    deletionIdempotencyKey: '',
    deletionBusy: false,
    deletionReturnFocus: null,
    reorderBusy: false,
    receiptRefreshTimer: 0,
    receiptRefreshAttempts: 0,
    receiptRefreshEpoch: 0
  };

  function label(name) { return labels[name] || ''; }

  function setMessage(node, message, success) {
    if (disposed || !node) return;
    node.textContent = message || '';
    node.classList.toggle('is-success', Boolean(success));
  }

  function show(name) {
    if (disposed) return;
    loading.hidden = name !== 'loading';
    errorBox.hidden = name !== 'error';
    auth.hidden = name !== 'auth';
    app.hidden = name !== 'app';
  }

  function showAuthView(name) {
    if (disposed) return;
    root.querySelectorAll('[data-auth-view]').forEach(function (view) {
      view.hidden = view.dataset.authView !== name;
    });
    setMessage(authStatus, '');
  }

  function setAuthMode(mode) {
    if (disposed || state.authSending) return;
    state.authMode = mode === 'register' ? 'register' : 'login';
    var registering = state.authMode === 'register';
    var nameField = phoneForm.elements.full_name;
    var nameWrapper = root.querySelector('[data-auth-name-field]');
    var title = root.querySelector('[data-auth-title]');
    if (nameWrapper) nameWrapper.hidden = !registering;
    nameField.disabled = !registering;
    nameField.required = registering;
    if (!registering) nameField.value = '';
    if (title) title.textContent = registering ? title.dataset.registerTitle : title.dataset.loginTitle;
    root.querySelectorAll('[data-auth-mode]').forEach(function (button) {
      button.hidden = button.dataset.authMode === state.authMode;
    });
    state.fullName = '';
    state.challengeId = '';
    state.phone = '';
    codeForm.reset();
    showAuthView('phone');
  }

  root.querySelectorAll('[data-auth-mode]').forEach(function (button) {
    button.addEventListener('click', function () {
      setAuthMode(button.dataset.authMode);
      (state.authMode === 'register' ? phoneForm.elements.full_name : phoneForm.elements.phone).focus();
    });
  });

  function errorText(error) {
    if (error && error.code === 'ACCOUNT_NOT_FOUND') return isRtl ? 'ليس لديك حساب مسجل بهذا الرقم. اختر «إنشاء حساب جديد».' : 'No account is registered with this phone number. Choose Create a new account.';
    if (error && error.status === 429) return label('tooManyRequests');
    if (error && error.status === 401) return label('authRequired');
    if (error && error.code === 'ADDRESS_LIMIT_REACHED') return label('addressLimit');
    if (error && error.code === 'ADDRESS_PROVINCE_NOT_PERSISTED') return label('provinceSaveFailed');
    if (error && error.code === 'ADDRESS_PROVINCE_COMPATIBILITY_CONFLICT') return label('provinceCityConflict');
    if (error && /^SHOPIFY_ADDRESS_(CREATE|UPDATE)_FAILED$/.test(error.code || '')) return label('addressRejected');
    return label('requestFailed');
  }

  function handleSessionError(error) {
    if (disposed) return true;
    if (error && error.status === 401) {
      if (addressDialog && addressDialog.open) closeAddressDialog();
      clearAuthenticatedState();
      return true;
    }
    return false;
  }

  function clearAuthenticatedState() {
    if (disposed) return;
    if (accountRefresh) accountRefresh.stop();
    window.clearTimeout(state.receiptRefreshTimer);
    state.receiptRefreshTimer = 0;
    state.receiptRefreshAttempts = 0;
    state.receiptRefreshEpoch += 1;
    state.profile = null;
    state.addresses = [];
    state.createAttempt = null;
    if (window.RwadyAvatar && typeof window.RwadyAvatar.logout === 'function') {
      window.RwadyAvatar.logout();
    } else {
      document.dispatchEvent(new CustomEvent('rwady:account-logout'));
    }
    showAuthView('phone');
    show('auth');
  }

  function deletionErrorText(error) {
    var code = String(error && error.code || '');
    if (error && error.status === 401 || code === 'AUTH_REQUIRED') return label('deletionAuthRequired');
    if (code === 'INVALID_DELETION_OTP') return label('deletionIncorrectCode');
    if (code === 'INVALID_DELETION_CHALLENGE') return label('deletionExpiredCode');
    if (error && error.status === 429 || /^(DELETION_MAX_ATTEMPTS|DELETION_RESEND_WAIT|DELETION_PHONE_LIMIT|DELETION_IP_LIMIT)$/.test(code)) return label('deletionTooMany');
    if (code === 'ACCOUNT_DELETION_IN_PROGRESS') return label('deletionInProgress');
    return label('deletionUnavailable');
  }

  function deletionReference(error) {
    var payload = error && error.payload || {};
    return String(payload.support_reference || payload.supportReference || '').trim().slice(0, 160);
  }

  function showDeletionView(name) {
    root.querySelectorAll('[data-account-deletion-view]').forEach(function (view) {
      view.hidden = view.dataset.accountDeletionView !== name;
    });
    var title = root.querySelector('[data-account-deletion-title]');
    if (title) title.textContent = name === 'code' ? title.dataset.codeTitle : (name === 'success' ? title.dataset.successTitle : title.dataset.warningTitle);
  }

  function resetDeletionDialog() {
    state.deletionChallengeId = '';
    state.deletionIdempotencyKey = '';
    state.deletionBusy = false;
    deletionForm.reset();
    showDeletionView('warning');
    setMessage(deletionStatus, '');
    root.querySelector('[data-account-deletion-reference]').hidden = true;
    root.querySelector('[data-account-deletion-continue]').disabled = false;
    root.querySelector('[data-account-deletion-submit]').disabled = false;
  }

  function closeDeletionDialog() {
    if (state.deletionBusy) return;
    if (typeof deletionDialog.close === 'function') deletionDialog.close();
    else deletionDialog.removeAttribute('open');
    resetDeletionDialog();
    if (state.deletionReturnFocus && document.contains(state.deletionReturnFocus)) state.deletionReturnFocus.focus();
    state.deletionReturnFocus = null;
  }

  function showDeletionError(error) {
    setMessage(deletionStatus, deletionErrorText(error));
    var reference = deletionReference(error);
    var box = root.querySelector('[data-account-deletion-reference]');
    box.hidden = !reference;
    if (reference) {
      root.querySelector('[data-account-deletion-reference-text]').textContent = label('deletionReference') + ' ' + reference;
      root.querySelector('[data-account-deletion-copy]').textContent = label('deletionCopy');
      box.dataset.reference = reference;
    }
  }

  root.querySelector('[data-account-delete-open]').addEventListener('click', function (event) {
    resetDeletionDialog();
    state.deletionReturnFocus = event.currentTarget;
    if (typeof deletionDialog.showModal === 'function') deletionDialog.showModal();
    else deletionDialog.setAttribute('open', '');
    root.querySelector('[data-account-deletion-continue]').focus();
  });

  root.querySelectorAll('[data-account-deletion-cancel]').forEach(function (button) {
    button.addEventListener('click', closeDeletionDialog);
  });

  deletionDialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    if (!state.deletionBusy) closeDeletionDialog();
  });

  deletionDialog.addEventListener('click', function (event) {
    if (event.target === deletionDialog) closeDeletionDialog();
  });

  root.querySelector('[data-account-deletion-continue]').addEventListener('click', function (event) {
    if (state.deletionBusy) return;
    var button = event.currentTarget;
    state.deletionBusy = true;
    button.disabled = true;
    setMessage(deletionStatus, label('deletionStarting'));
    api.startAccountDeletion().then(function (payload) {
      var challengeId = String(payload && payload.challenge_id || '');
      if (!payload || payload.ok !== true || !challengeId) throw new Error('INVALID_DELETION_START_RESPONSE');
      state.deletionChallengeId = challengeId;
      state.deletionIdempotencyKey = '';
      showDeletionView('code');
      setMessage(deletionStatus, '');
      deletionForm.elements.code.focus();
    }).catch(function (error) {
      showDeletionError(error);
      if (error && error.status === 401) clearAuthenticatedState();
    }).finally(function () {
      state.deletionBusy = false;
      button.disabled = false;
    });
  });

  normalizeInputDigits(deletionForm.elements.code, false);
  deletionForm.addEventListener('submit', function (event) {
    event.preventDefault();
    if (state.deletionBusy) return;
    var code = window.RwadyAccountApi.normalizeDigits(deletionForm.elements.code.value).replace(/\D/g, '').slice(0, 6);
    deletionForm.elements.code.value = code;
    if (!/^\d{6}$/.test(code)) {
      setMessage(deletionStatus, label('deletionInvalidCode'));
      deletionForm.elements.code.focus();
      return;
    }
    if (!state.deletionIdempotencyKey) state.deletionIdempotencyKey = window.RwadyAccountApi.secureDeletionIdempotencyKey();
    var button = root.querySelector('[data-account-deletion-submit]');
    state.deletionBusy = true;
    button.disabled = true;
    setMessage(deletionStatus, label('deletionConfirming'));
    api.confirmAccountDeletion(state.deletionChallengeId, code, state.deletionIdempotencyKey).then(function (payload) {
      var validShopifyAction = payload && /^(deleted|erasure_requested)$/.test(String(payload.shopify_action || ''));
      if (!payload || payload.ok !== true || payload.account_deleted !== true || payload.authenticated !== false || !validShopifyAction) {
        throw new Error('INVALID_DELETION_CONFIRM_RESPONSE');
      }
      state.profile = null;
      state.addresses = [];
      state.createAttempt = null;
      state.challengeId = '';
      state.phone = '';
      state.fullName = '';
      window.clearTimeout(state.resendTimer);
      if (window.RwadyAvatar && typeof window.RwadyAvatar.logout === 'function') window.RwadyAvatar.logout();
      else document.dispatchEvent(new CustomEvent('rwady:account-logout'));
      root.querySelector('[data-account-deletion-success-deleted]').hidden = payload.shopify_action !== 'deleted';
      root.querySelector('[data-account-deletion-success-erasure]').hidden = payload.shopify_action !== 'erasure_requested';
      showDeletionView('success');
      setMessage(deletionStatus, '');
      app.hidden = true;
      window.setTimeout(function () {
        window.location.assign(root.dataset.homeUrl || '/');
      }, 0);
    }).catch(function (error) {
      showDeletionError(error);
      if (error && error.status === 401) clearAuthenticatedState();
    }).finally(function () {
      state.deletionBusy = false;
      button.disabled = false;
    });
  });

  root.querySelector('[data-account-deletion-copy]').addEventListener('click', function (event) {
    var reference = event.currentTarget.parentElement.dataset.reference || '';
    if (!reference || !navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') return;
    navigator.clipboard.writeText(reference).then(function () {
      setMessage(deletionStatus, label('deletionCopied'), true);
    }).catch(function () {});
  });

  function normalizeInputDigits(input, phone) {
    input.addEventListener('input', function () {
      var value = window.RwadyAccountApi.normalizeDigits(input.value);
      input.value = phone ? value.replace(/[^0-9+]/g, '') : value.replace(/\D/g, '').slice(0, 6);
    });
  }

  normalizeInputDigits(phoneForm.elements.phone, true);
  normalizeInputDigits(codeForm.elements.code, false);
  normalizeInputDigits(profileForm.elements.alternate_phone, true);
  normalizeInputDigits(addressForm.elements.phone, true);
  normalizeInputDigits(addressForm.elements.secondary_phone, true);

  function setBusy(button, busy, busyText, normalText) {
    button.disabled = busy;
    button.textContent = busy ? busyText : normalText;
  }

  function updateResend() {
    window.clearTimeout(state.resendTimer);
    var seconds = Math.max(0, Math.ceil((state.resendAt - Date.now()) / 1000));
    resendButton.disabled = seconds > 0;
    resendButton.textContent = seconds ? label('resend') + ' (' + seconds + ')' : label('resend');
    if (seconds) state.resendTimer = window.setTimeout(updateResend, 1000);
  }

  function sendOtp(isResend) {
    if (state.authSending) return Promise.resolve(false);
    var phone = isResend ? state.phone : window.RwadyAccountApi.normalizePhone(phoneForm.elements.phone.value);
    var fullName = state.authMode === 'register' ? (isResend ? state.fullName : String(phoneForm.elements.full_name.value || '').trim()) : '';
    if (!phone) {
      setMessage(authStatus, label('invalidPhone'));
      phoneForm.elements.phone.focus();
      return Promise.resolve(false);
    }
    if (state.authMode === 'register' && !fullName) {
      setMessage(authStatus, label('requiredFields'));
      phoneForm.elements.full_name.focus();
      return Promise.resolve(false);
    }
    state.authSending = true;
    root.querySelectorAll('[data-auth-mode]').forEach(function (modeButton) { modeButton.disabled = true; });
    var button = isResend ? resendButton : root.querySelector('[data-auth-send]');
    setBusy(button, true, label('sending'), isResend ? label('resend') : label('sendCode'));
    setMessage(authStatus, '');
    var body = { phone: phone };
    if (state.authMode === 'login') { body.intent = 'login'; body.mode = 'login'; }
    if (fullName) body.full_name = fullName;
    return api.sendOtp(body).then(function (payload) {
      state.phone = phone;
      state.fullName = fullName;
      state.challengeId = String(payload.challenge_id || '');
      state.resendAt = Date.now() + (Number(payload.resend_after) || 60) * 1000;
      showAuthView('code');
      codeForm.elements.code.focus();
      return true;
    }).catch(function (error) {
      setMessage(authStatus, errorText(error));
      return false;
    }).finally(function () {
      state.authSending = false;
      root.querySelectorAll('[data-auth-mode]').forEach(function (modeButton) { modeButton.disabled = false; });
      setBusy(button, false, label('sending'), isResend ? label('resend') : label('sendCode'));
      updateResend();
    });
  }

  phoneForm.addEventListener('submit', function (event) {
    event.preventDefault();
    sendOtp(false);
  });

  codeForm.addEventListener('submit', function (event) {
    event.preventDefault();
    var code = window.RwadyAccountApi.normalizeDigits(codeForm.elements.code.value).replace(/\D/g, '');
    if (!/^\d{6}$/.test(code)) {
      setMessage(authStatus, label('invalidCode'));
      codeForm.elements.code.focus();
      return;
    }
    var button = root.querySelector('[data-auth-verify]');
    setBusy(button, true, label('verifying'), label('verify'));
    setMessage(authStatus, '');
    var body = { phone: state.phone, challenge_id: state.challengeId, code: code };
    if (state.fullName) body.full_name = state.fullName;
    api.verifyOtp(body).then(function () {
      return loadAccount();
    }).catch(function (error) {
      setMessage(authStatus, errorText(error));
    }).finally(function () {
      setBusy(button, false, label('verifying'), label('verify'));
    });
  });

  resendButton.addEventListener('click', function () {
    if (Date.now() >= state.resendAt) sendOtp(true);
  });

  root.querySelector('[data-auth-change-phone]').addEventListener('click', function () {
    state.challengeId = '';
    state.phone = '';
    state.fullName = '';
    codeForm.reset();
    showAuthView('phone');
    phoneForm.elements.phone.focus();
  });

  function valueOrDash(value) {
    return value === null || value === undefined || String(value).trim() === '' ? '—' : String(value);
  }

  function renderProfile(profile) {
    if (disposed) return;
    var fullName = profile.full_name || [profile.first_name, profile.last_name].filter(Boolean).join(' ');
    root.querySelector('[data-profile-full-name]').textContent = valueOrDash(fullName);
    root.querySelector('[data-profile-email]').textContent = valueOrDash(profile.email);
    root.querySelector('[data-profile-primary-phone]').textContent = valueOrDash(profile.primary_phone);
    root.querySelector('[data-profile-alternate-phone]').textContent = valueOrDash(profile.alternate_phone);
    root.querySelector('[data-profile-display-name]').textContent = valueOrDash(fullName);
    root.querySelector('[data-profile-overview-name]').textContent = valueOrDash(fullName);
    root.querySelector('[data-profile-overview-email]').textContent = valueOrDash(profile.email);
    root.querySelector('[data-delete-alternate-phone]').hidden = !profile.alternate_phone;
    window.RwadyAvatar.setProfile(profile, { loading: true });
  }

  function renderAvatar(avatarState) {
    if (disposed) return;
    var image = root.querySelector('[data-account-avatar-image]');
    var initials = root.querySelector('[data-account-avatar-initials]');
    var fallback = root.querySelector('[data-account-avatar-fallback]');
    var container = root.querySelector('[data-account-avatar]');
    var hasImage = Boolean(avatarState && avatarState.imageUrl);
    var hasInitials = !hasImage && Boolean(avatarState && avatarState.initials);
    container.setAttribute('aria-busy', String(Boolean(avatarState && avatarState.loading)));
    image.hidden = !hasImage;
    if (hasImage && image.src !== avatarState.imageUrl) image.src = avatarState.imageUrl;
    if (!hasImage) image.removeAttribute('src');
    initials.hidden = !hasInitials;
    initials.textContent = hasInitials ? avatarState.initials : '';
    fallback.hidden = hasImage || hasInitials;
    root.querySelector('[data-avatar-delete]').hidden = !hasImage;
  }

  function avatarErrorText(error) {
    if (error && error.status === 429) return label('avatarRetryLater');
    if (error && error.status === 413) return label('avatarTooLarge');
    if (error && error.status === 415) return label('avatarUnsupported');
    if (error && (error.code === 'AVATAR_UNSUPPORTED_TYPE' || error.code === 'AVATAR_DECODE_FAILED')) return label('avatarUnsupported');
    if (error && (error.code === 'AVATAR_SOURCE_TOO_LARGE' || error.code === 'AVATAR_OUTPUT_TOO_LARGE')) return label('avatarTooLarge');
    return label('avatarUploadFailed');
  }

  function loadAvatar(profile) {
    setMessage(avatarStatus, label('avatarLoading'));
    return api.avatar().then(function (blob) {
      if (disposed) return;
      if (blob) window.RwadyAvatar.setBlob(blob, profile);
      else window.RwadyAvatar.clearImage(profile);
      setMessage(avatarStatus, '');
    }).catch(function (error) {
      if (disposed) return;
      if (error && error.status === 401) {
        window.RwadyAvatar.logout();
        handleSessionError(error);
        return;
      }
      window.RwadyAvatar.clearImage(profile);
      setMessage(avatarStatus, error.status === 429 ? label('avatarRetryLater') : '');
    });
  }

  function makeElement(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function addressFullName(address) {
    return address.full_name || [address.first_name, address.last_name].filter(Boolean).join(' ');
  }

  function appendAddressRow(container, term, value, phone) {
    var row = makeElement('div', 'rwady-account-address__row');
    row.appendChild(makeElement('span', '', term));
    var output = makeElement('strong', '', valueOrDash(value));
    output.dir = phone ? 'ltr' : 'auto';
    row.appendChild(output);
    container.appendChild(row);
  }

  function provinceDisplay(address) {
    var code = provinceValue(address.province_code || address.provinceCode || address.province);
    var option = code && addressForm.elements.province.querySelector('option[value="' + code + '"]');
    return option ? option.textContent.trim() : valueOrDash(address.province);
  }

  function appendAddressDetails(container, address) {
    appendAddressRow(container, label('fullName'), addressFullName(address), false);
    appendAddressRow(container, label('phone'), address.phone, true);
    if (address.secondary_phone) appendAddressRow(container, label('secondaryPhone'), address.secondary_phone, true);
    appendAddressRow(container, label('province'), provinceDisplay(address), false);
    appendAddressRow(container, label('areaLandmark'), address.address1, false);
  }

  function defaultAddress() {
    return state.addresses.find(function (address) { return Boolean(address.is_default); }) || null;
  }

  function renderDefaultAddress() {
    var address = defaultAddress();
    var content = root.querySelector('[data-profile-default-address-content]');
    var badge = root.querySelector('[data-profile-default-badge]');
    var edit = root.querySelector('[data-edit-default-address]');
    var add = root.querySelector('[data-add-default-address]');
    var overview = root.querySelector('[data-profile-overview-address]');
    content.textContent = '';
    badge.hidden = !address;
    edit.hidden = !address;
    add.hidden = Boolean(address);
    if (!address) {
      overview.textContent = label('noDefaultAddress');
      content.appendChild(makeElement('p', 'rwady-account-empty rwady-account-empty--compact', label('noDefaultAddress')));
      return;
    }
    overview.textContent = address.label || provinceDisplay(address);
    content.appendChild(makeElement('h4', '', address.label || '—'));
    var details = makeElement('div', 'rwady-account-address__details');
    appendAddressRow(details, label('province'), provinceDisplay(address), false);
    appendAddressRow(details, label('areaLandmark'), address.address1, false);
    appendAddressRow(details, label('phone'), address.phone, true);
    if (address.secondary_phone) appendAddressRow(details, label('secondaryPhone'), address.secondary_phone, true);
    content.appendChild(details);
  }

  function interpolate(template, values) {
    return String(template || '').replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, function (_match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : '';
    });
  }

  function renderAddresses() {
    if (disposed) return;
    var list = root.querySelector('[data-address-list]');
    var count = state.addresses.length;
    list.textContent = '';
    root.querySelector('[data-address-count]').textContent = interpolate(label('addressCount'), { count: count });
    var addButton = root.querySelector('[data-add-address]');
    addButton.disabled = count >= 10;
    addButton.title = count >= 10 ? label('addressLimit') : '';
    if (!count) {
      list.appendChild(makeElement('p', 'rwady-account-empty', label('noAddresses')));
      renderDefaultAddress();
      return;
    }
    state.addresses.forEach(function (address) {
      var card = makeElement('article', 'rwady-account-address');
      var head = makeElement('div', 'rwady-account-address__head');
      head.appendChild(makeElement('h3', '', address.label || '—'));
      if (address.is_default) head.appendChild(makeElement('span', 'rwady-account-badge', label('defaultBadge')));
      card.appendChild(head);
      var details = makeElement('div', 'rwady-account-address__details');
      appendAddressDetails(details, address);
      card.appendChild(details);
      var actions = makeElement('div', 'rwady-account-address__actions');
      var edit = makeElement('button', '', label('edit'));
      edit.type = 'button';
      edit.dataset.editAddress = address.id;
      actions.appendChild(edit);
      if (!address.is_default) {
        var defaultButton = makeElement('button', '', label('setDefault'));
        defaultButton.type = 'button';
        defaultButton.dataset.defaultAddress = address.id;
        actions.appendChild(defaultButton);
      }
      var remove = makeElement('button', '', label('delete'));
      remove.type = 'button';
      remove.dataset.deleteAddress = address.id;
      actions.appendChild(remove);
      card.appendChild(actions);
      list.appendChild(card);
    });
    renderDefaultAddress();
  }

  function money(value) {
    if (!value || value.amount === '' || value.amount === null || value.amount === undefined) return '—';
    var amount = Number(value.amount);
    var formatted = Number.isFinite(amount) ? new Intl.NumberFormat('en-IQ', { maximumFractionDigits: 2 }).format(amount) : String(value.amount);
    var currency = String(value.currency_code || 'IQD').toUpperCase();
    return formatted + ' ' + (isRtl && currency === 'IQD' ? 'د.ع' : currency);
  }

  function formatDate(value) {
    var date = new Date(value);
    if (!value || Number.isNaN(date.getTime())) return '—';
    return new Intl.DateTimeFormat(isRtl ? 'ar-IQ' : 'en-IQ', { year: 'numeric', month: 'short', day: 'numeric' }).format(date);
  }

  function translateOrderStatus(value, kind) {
    var normalized = String(value || '').trim().toUpperCase().replace(/[\s-]+/g, '_');
    var maps = kind === 'financial' ? {
      AUTHORIZED: 'financialAuthorized', PAID: 'financialPaid', PARTIALLY_PAID: 'financialPartiallyPaid',
      PARTIALLY_REFUNDED: 'financialPartiallyRefunded', PENDING: 'financialPending', REFUNDED: 'financialRefunded',
      VOIDED: 'financialVoided', EXPIRED: 'financialExpired'
    } : {
      FULFILLED: 'fulfillmentFulfilled', IN_PROGRESS: 'fulfillmentInProgress', ON_HOLD: 'fulfillmentOnHold',
      OPEN: 'fulfillmentOpen', PARTIALLY_FULFILLED: 'fulfillmentPartiallyFulfilled', PENDING: 'fulfillmentPending',
      RESTOCKED: 'fulfillmentRestocked', SCHEDULED: 'fulfillmentScheduled', UNFULFILLED: 'fulfillmentUnfulfilled'
    };
    return maps[normalized] ? label(maps[normalized]) : valueOrDash(value);
  }

  function shopifyRootPath() {
    var path = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || root.dataset.shopifyRoot || '/';
    path = String(path || '/');
    if (path.charAt(0) !== '/') path = '/' + path;
    return path.endsWith('/') ? path : path + '/';
  }

  function reorderText(name, count) {
    return label(name).replace('%count%', String(Math.max(0, Number(count) || 0)));
  }

  function loadCurrentReorderProducts(order) {
    var handles = [];
    var seen = {};
    (Array.isArray(order && order.items) ? order.items : []).forEach(function (item) {
      var handle = String(item && item.product_handle || '').trim();
      if (!handle || seen[handle]) return;
      seen[handle] = true;
      handles.push(handle);
    });
    return Promise.all(handles.map(function (handle) {
      return window.fetch(shopifyRootPath() + 'products/' + encodeURIComponent(handle) + '.js', {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) return null;
        return response.json().catch(function () { return null; });
      }).catch(function () { return null; }).then(function (product) {
        return { handle: handle, product: product };
      });
    })).then(function (entries) {
      var products = {};
      entries.forEach(function (entry) { products[entry.handle] = entry.product; });
      return products;
    });
  }

  function setReorderButtonsDisabled(disabled) {
    root.querySelectorAll('[data-account-reorder]').forEach(function (candidate) {
      candidate.disabled = Boolean(disabled) || candidate.dataset.reorderAvailable !== 'true';
    });
  }

  function reorderOrderItem(item, button, status) {
    if (disposed || state.reorderBusy) return;
    state.reorderBusy = true;
    setReorderButtonsDisabled(true);
    setMessage(status, label('reorderChecking'));
    var cartRequestStarted = false;
    loadCurrentReorderProducts({ items: [item] }).then(function (products) {
      var plan = window.RwadyAccountApi.buildLineReorderPlan(item, products);
      if (!plan.items.length) {
        setMessage(status, label('reorderNoneAvailable'));
        state.reorderBusy = false;
        setReorderButtonsDisabled(false);
        return null;
      }
      setMessage(status, label('reorderAdding'));
      cartRequestStarted = true;
      return window.fetch(root.dataset.cartAddUrl || shopifyRootPath() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: plan.items.map(function (item) { return { id: item.id, quantity: item.quantity }; })
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('REORDER_CART_ADD_FAILED');
        return response.json().catch(function () { return {}; });
      }).then(function () {
        var message = plan.skipped.length
          ? reorderText('reorderPartial', plan.skipped.length)
          : reorderText('reorderAdded', plan.items.length);
        setMessage(status, message, true);
        if (plan.skipped.length && typeof window.alert === 'function') window.alert(message);
        window.location.assign(root.dataset.cartUrl || shopifyRootPath() + 'cart');
        return true;
      });
    }).catch(function () {
      setMessage(status, cartRequestStarted ? label('reorderCartUncertain') : label('reorderUnavailable'));
      state.reorderBusy = false;
      if (!cartRequestStarted) setReorderButtonsDisabled(false);
      else button.disabled = true;
    });
  }

  function orderTrackingStatus(order) {
    var known = ['awaiting_confirmation', 'confirmed', 'ready', 'shipped', 'in_transit', 'delivered', 'cancelled'];
    var status = known.indexOf(order.tracking_status) !== -1 ? order.tracking_status
      : (order.fulfillment_status === 'FULFILLED' ? 'shipped' : 'awaiting_confirmation');
    if (status !== 'awaiting_confirmation') return status;
    var items = order.items || [];
    var lines = order.line_fulfillment && order.line_fulfillment.lines || [];
    var allProductsConfirmed = items.length > 0 && items.every(function (item) {
      return lines.some(function (line) {
        return String(line.line_item_id || '') === String(item.line_item_id || '')
          && line.availability_confirmed === true
          && line.availability !== 'pending';
      });
    });
    return allProductsConfirmed ? 'confirmed' : status;
  }

  function orderTrackingLabel(order) {
    var statuses = {
      awaiting_confirmation: ['بانتظار تأكيد الطلب', 'Awaiting confirmation'],
      confirmed: ['بانتظار الشحن', 'Awaiting shipment'],
      ready: ['جاري التوصيل', 'Delivery in progress'],
      shipped: ['تم الشحن', 'Shipped'],
      in_transit: ['الطلب مع مندوب التوصيل', 'With the delivery courier'],
      delivered: ['تم التسليم', 'Delivered'],
      cancelled: ['ملغاة', 'Cancelled']
    };
    var status = orderTrackingStatus(order);
    return statuses[status][isRtl ? 0 : 1];
  }

  function lineStatusText(status) {
    var labels = {
      unknown: ['بانتظار تحديث حالة المنتج', 'Product status not updated'],
      awaiting_confirmation: ['بانتظار تأكيد الطلب', 'Awaiting confirmation'],
      awaiting_shipment: ['بانتظار الشحن', 'Awaiting shipment'],
      confirmed: ['بانتظار الشحن', 'Awaiting shipment'],
      ready: ['جاري التوصيل', 'Delivery in progress'],
      reserved: ['بانتظار الشحن', 'Awaiting shipment'],
      shipped: ['تم الشحن', 'Shipped'],
      in_transit: ['الطلب مع مندوب التوصيل', 'With the delivery courier'],
      returned: ['راجع', 'Returned'],
      delivered: ['تم التسليم', 'Delivered'],
      partially_shipped: ['مشحون جزئياً', 'Partially shipped'],
      partially_delivered: ['مسلّم جزئياً', 'Partially delivered'],
      cancelled: ['ملغاة', 'Cancelled']
    };
    return (labels[status] || labels.unknown)[isRtl ? 0 : 1];
  }

  function renderOrderItem(entry, currentProducts, shipment, closedOrder, groupKind) {
    var item = entry.item;
    var row = makeElement('div', 'rwady-account-order-item');
    if (item.image_url) {
      var image = document.createElement('img');
      image.src = item.image_url;
      image.alt = item.image_alt || item.product_title || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      row.appendChild(image);
    } else row.appendChild(makeElement('span', 'rwady-account-order-item__image', '—'));
    var details = makeElement('div', 'rwady-account-order-item__details');
    // Summary is single-line; expanding reveals the entire name on touch or
    // keyboard without shrinking the text to fit a narrow phone.
    var titleDisclosure = makeElement('details', 'rwady-account-order-item__name');
    var title = makeElement('summary', 'rwady-account-order-item__title', valueOrDash(item.product_title));
    title.setAttribute('dir', 'auto');
    title.title = item.product_title || '';
    titleDisclosure.appendChild(title);
    var fullTitle = makeElement(item.product_url ? 'a' : 'p', 'rwady-account-order-item__full-title', valueOrDash(item.product_title));
    fullTitle.setAttribute('dir', 'auto');
    if (item.product_url) fullTitle.href = item.product_url;
    titleDisclosure.appendChild(fullTitle);
    details.appendChild(titleDisclosure);
    if (item.variant_title && item.variant_title !== 'Default Title') details.appendChild(makeElement('span', '', item.variant_title));
    var unit = item.discounted_unit_price != null ? item.discounted_unit_price : item.unit_price;
    var amount = unit && unit.amount != null && unit.amount !== '' ? Number(unit.amount) : NaN;
    var total = Number.isFinite(amount) ? { amount: String(Math.round(amount * entry.quantity * 100) / 100), currency_code: unit.currency_code } : null;
    var formula = makeElement('strong', 'rwady-account-order-item__price');
    formula.setAttribute('dir', 'ltr');
    // Isolate numeric operands from Arabic currency; show the currency once,
    // with the total, so bidi reordering cannot move it across operators.
    var numberFormat = new Intl.NumberFormat('en-IQ', { maximumFractionDigits: 2 });
    var calculation = makeElement('bdi', 'rwady-account-order-item__calculation',
      (Number.isFinite(amount) ? numberFormat.format(amount) : '—') + ' × ' + entry.quantity + ' = ');
    calculation.setAttribute('dir', 'ltr');
    formula.appendChild(calculation);
    var result = makeElement('span', 'rwady-account-order-item__amount');
    result.setAttribute('dir', 'ltr');
    var currencyCode = String(unit && unit.currency_code || 'IQD').toUpperCase();
    var currency = makeElement('bdi', 'rwady-account-order-item__currency',
      (isRtl && currencyCode === 'IQD' ? 'د.ع' : currencyCode) + ' ');
    currency.setAttribute('dir', isRtl && currencyCode === 'IQD' ? 'rtl' : 'ltr');
    result.appendChild(currency);
    var number = makeElement('bdi', '', total ? numberFormat.format(Number(total.amount)) : '—');
    number.setAttribute('dir', 'ltr');
    result.appendChild(number);
    formula.appendChild(result);
    details.appendChild(formula);
    if (entry.quantity !== item.quantity) details.appendChild(makeElement('span', '', isRtl
      ? 'هذه المجموعة: ' + entry.quantity + ' من أصل ' + item.quantity
      : 'This group: ' + entry.quantity + ' of ' + item.quantity));
    var actions = makeElement('div', 'rwady-account-order-item__actions');
    var button = makeElement('button', 'rwady-account-reorder', label('reorder'));
    button.type = 'button';
    button.setAttribute('data-account-reorder', '');
    button.disabled = true;
    button.dataset.reorderAvailable = 'false';
    currentProducts.then(function (products) {
      if (disposed) return;
      var plan = window.RwadyAccountApi.buildLineReorderPlan(Object.assign({}, item, { quantity: entry.quantity }), products);
      button.dataset.reorderAvailable = plan.items.length ? 'true' : 'false';
      button.disabled = state.reorderBusy || !plan.items.length;
      button.title = plan.items.length ? '' : (isRtl ? 'المنتج غير متاح للشراء حاليًا' : 'Product currently unavailable to buy');
    });
    button.setAttribute('aria-label', label('reorder') + ': ' + valueOrDash(item.product_title));
    var message = makeElement('p', 'rwady-account-reorder__status', '');
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    button.addEventListener('click', function () {
      if (button.disabled || button.dataset.reorderAvailable !== 'true') return;
      reorderOrderItem(Object.assign({}, item, { quantity: entry.quantity }), button, message);
    });
    actions.appendChild(button);
    var availability = entry.line && entry.line.availability;
    var customerRemoved = entry.status === 'cancelled' && entry.line && entry.line.removal_reason === 'customer_request';
    if (!closedOrder && entry.status !== 'delivered' && entry.status !== 'cancelled' && entry.line && entry.line.availability_confirmed === true &&
        (availability === 'available' || availability === 'unavailable')) {
      var availableText = availability === 'available' ? (isRtl ? 'متوفر' : 'Available')
        : (isRtl ? 'غير متوفر' : 'Unavailable');
      var badge = makeElement('span', 'rwady-account-order-item__availability', availableText);
      badge.dataset.availability = availability;
      actions.appendChild(badge);
    }
    details.appendChild(actions);
    var unavailableUnprepared = entry.line &&
      entry.line.availability_confirmed === true && availability === 'unavailable' &&
      ['awaiting_confirmation', 'confirmed', 'awaiting_shipment', 'unallocated'].indexOf(entry.status) !== -1;
    if (customerRemoved || (!shipment && !unavailableUnprepared)) {
      var status = makeElement('span', 'rwady-account-order-item__fulfillment', groupKind === 'cancelled_shipment' ? (isRtl ? 'ملغى بعد الشحن' : 'Cancelled after shipment') : customerRemoved
        ? (isRtl ? 'ملغى بطلب من الزبون' : 'Cancelled at customer request') : lineStatusText(entry.status));
      status.dataset.status = entry.status;
      details.appendChild(status);
    }
    details.appendChild(message);
    row.appendChild(details);
    return row;
  }

  function availableProductsTotal(order) {
    var snapshot = order.line_fulfillment;
    if (order.has_more_items || !snapshot || !snapshot.updated_at) return null;
    var lines = new Map((snapshot.lines || []).map(function (line) { return [line.line_item_id, line]; }));
    var cents = 0;
    var currency = order.total && order.total.currency_code || 'IQD';
    var items = order.items || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i], line = lines.get(item.line_item_id);
      if (!line || line.status === 'cancelled') continue;
      if (line.availability_confirmed !== true || line.availability !== 'available') continue;
      var unit = item.discounted_unit_price != null ? item.discounted_unit_price : item.unit_price;
      var amount = unit && unit.amount != null && unit.amount !== '' ? Number(unit.amount) : NaN;
      if (!Number.isFinite(amount) || amount < 0 || !Number.isSafeInteger(item.quantity) ||
          item.quantity < 0 || unit.currency_code !== currency) return null;
      cents += Math.round(amount * item.quantity * 100);
    }
    return { amount: String(cents / 100), currency_code: currency };
  }

  function orderDelivery(order) {
    var shipping = order.line_fulfillment && order.line_fulfillment.shipping;
    if (shipping === undefined) return { value: order.shipping, pending: false };
    var validStatus = shipping && ['priced', 'no_shippable_items', 'frozen_dispatched', 'needs_retry'].includes(shipping.status);
    var amount = shipping && shipping.amount;
    var validAmount = (typeof amount === 'number' || typeof amount === 'string') &&
      String(amount).trim() !== '' && Number.isFinite(Number(amount)) && Number(amount) >= 0;
    var currency = order.total && order.total.currency_code || 'IQD';
    var valid = validStatus && validAmount && shipping.currency === currency &&
      (shipping.status !== 'no_shippable_items' || Number(amount) === 0);
    return {
      value: valid ? { amount: String(amount), currency_code: currency } : null,
      pending: !valid || shipping.status === 'needs_retry'
    };
  }

  function openNotificationOrder(list) {
    var params;
    try { params = new URL(window.location.href).searchParams; } catch (error) { return; }
    var orderId = params.get('order_id');
    if (!orderId || state.openedNotificationOrder === orderId + ':' + (params.get('shipment_id') || '')) return;
    var card = Array.from(list.children).find(function (node) { return node.dataset.orderId === orderId; });
    if (!card) return;
    selectAccountTab('orders', false);
    card.open = true;
    var shipmentId = params.get('shipment_id');
    var target = shipmentId && Array.from(card.querySelectorAll('[data-shipment-id]')).find(function (node) {
      return node.dataset.shipmentId === shipmentId;
    }) || card;
    state.openedNotificationOrder = orderId + ':' + (shipmentId || '');
    window.requestAnimationFrame(function () {
      if (disposed || !target.isConnected) return;
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
      target.classList.add('rwady-account-notification-target');
      window.setTimeout(function () { target.classList.remove('rwady-account-notification-target'); }, 3500);
    });
  }

  function trustedReceiptUrl(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    try {
      var url = new URL(raw, window.location.origin);
      return url.protocol === 'https:' && url.origin === 'https://sales.rwady.com' ? url.href : '';
    } catch (error) {
      return '';
    }
  }

  function receiptPdfFileUrl(receipt) {
    if (!receipt || receipt.pdf_status !== 'ready') return '';
    return trustedReceiptUrl(receipt.pdf_file_url);
  }

  function refreshReceiptFiles() {
    if (disposed) return;
    var epoch = state.receiptRefreshEpoch;
    state.receiptRefreshAttempts += 1;
    return api.receipts().then(function (result) {
      if (disposed || epoch !== state.receiptRefreshEpoch) return;
      renderReceipts(result.receipts || [], []);
    }).catch(function (error) {
      if (disposed || epoch !== state.receiptRefreshEpoch) return;
      if (!handleSessionError(error)) {
        var status = root.querySelector('[data-receipt-refresh-status]');
        if (status) status.textContent = isRtl ? 'تعذر تحديث حالة الملف. حدّث الصفحة للمحاولة مجددًا.' : 'Could not refresh the file. Reload to retry.';
      }
    });
  }

  function renderReceipts(receiptRows, orders) {
    var list = root.querySelector('[data-receipts-list]');
    if (!list) return;
    window.clearTimeout(state.receiptRefreshTimer);
    state.receiptRefreshTimer = 0;
    var pendingFiles = false;
    list.textContent = '';
    var receipts = (Array.isArray(receiptRows) ? receiptRows : []).map(function (receipt) {
      if (!receipt || !receipt.url) return null;
      try {
        var url = trustedReceiptUrl(receipt.url);
        if (!url) return null;
        return {
          order: { name: receipt.order_name || receipt.invoice_number || '' },
          receipt: receipt,
          url: receiptPdfFileUrl(receipt),
          updatedAt: receipt.generated_at || ''
        };
      } catch (error) {
        return null;
      }
    }).filter(Boolean);

    if (!receipts.length) {
      receipts = (orders || []).map(function (order) {
        var fulfillment = order && order.line_fulfillment || {};
        var receipt = fulfillment.receipt || null;
        if (!receipt || receipt.available !== true || !receipt.url) return null;
        try {
          var url = trustedReceiptUrl(receipt.url);
          if (!url) return null;
          return {
            order: order,
            receipt: receipt,
            url: receiptPdfFileUrl(receipt),
            updatedAt: fulfillment.updated_at || order.processed_at || ''
          };
        } catch (error) {
          return null;
        }
      }).filter(Boolean);
    }

    if (!receipts.length) {
      list.appendChild(makeElement('p', 'rwady-account-empty', isRtl
        ? 'لا توجد وصولات شراء متاحة حاليًا. سيظهر الوصل هنا بعد تأكيد الطلب.'
        : 'No purchase receipts are available yet. Your receipt will appear here after order confirmation.'));
      return;
    }

    receipts.forEach(function (entry) {
      var card = makeElement('article', 'rwady-account-receipt');
      var details = makeElement('div', 'rwady-account-receipt__details');
      details.appendChild(makeElement('h3', '', (isRtl ? 'وصل الطلب ' : 'Receipt for order ') + valueOrDash(entry.order.name)));
      details.appendChild(makeElement('p', '', isRtl ? 'يتضمن وصل الشراء وضمان كل منتج مؤكد.' : 'Includes the purchase receipt and warranty for each confirmed product.'));
      if (entry.updatedAt) {
        var time = makeElement('time', '', formatDate(entry.updatedAt));
        time.dateTime = entry.updatedAt;
        details.appendChild(time);
      }
      var actions = makeElement('div', 'rwady-account-receipt__actions', '');
      var ready = Boolean(entry.url);
      var action = makeElement(ready ? 'a' : 'button', 'rwady-account-receipt__action', isRtl ? 'تحميل الوصل PDF' : 'Download receipt PDF');
      if (ready) {
        action.href = entry.url;
        action.download = '';
        action.rel = 'noopener noreferrer';
        action.referrerPolicy = 'no-referrer';
        var linkCreatedAt = Date.now();
        action.addEventListener('click', function (event) {
          // Grants expire after five minutes. Refresh old links before using them.
          if (Date.now() - linkCreatedAt < 240000) return;
          event.preventDefault();
          action.textContent = isRtl ? 'جارٍ تحديث رابط التحميل…' : 'Refreshing download link…';
          refreshReceiptFiles().finally(function () {
            if (!disposed && action.isConnected) action.textContent = isRtl ? 'اضغط لتحديث رابط التحميل' : 'Refresh download link';
          });
        });
      } else {
        var status = makeElement('p', 'rwady-account-receipt__status', '');
        status.setAttribute('role', 'status');
        status.setAttribute('data-receipt-refresh-status', '');
        var preparing = ['pending', 'processing', 'queued'].indexOf(entry.receipt.pdf_status) !== -1;
        var polling = preparing && state.receiptRefreshAttempts < 12;
        status.textContent = polling
          ? (isRtl ? 'جارٍ تجهيز نسخة PDF…' : 'Preparing your PDF…')
          : (isRtl ? 'الملف غير جاهز. اضغط لتحديث حالته.' : 'The PDF is not ready. Click to refresh its status.');
        action.type = 'button';
        action.disabled = polling;
        action.addEventListener('click', function () {
          action.disabled = true;
          state.receiptRefreshAttempts = 0;
          refreshReceiptFiles().finally(function () {
            if (!disposed && action.isConnected) action.disabled = false;
          });
        });
        details.appendChild(status);
        pendingFiles = pendingFiles || polling;
      }
      actions.appendChild(action);
      card.appendChild(details);
      card.appendChild(actions);
      list.appendChild(card);
    });
    if (pendingFiles) {
      state.receiptRefreshTimer = window.setTimeout(refreshReceiptFiles, 5000);
    }
  }

  function renderOrders(orders) {
    if (disposed) return;
    var list = root.querySelector('[data-orders-list]');
    root.querySelector('[data-profile-order-count]').textContent = String(orders.length);
    var expandedOrders = [];
    Array.prototype.forEach.call(list.children, function (card) {
      if (card.open && card.dataset.orderId) expandedOrders.push(card.dataset.orderId);
    });
    list.textContent = '';
    if (!orders.length) {
      list.appendChild(makeElement('p', 'rwady-account-empty', label('noOrders')));
      return;
    }
    orders.forEach(function (order) {
      var card = makeElement('details', 'rwady-account-order');
      card.dataset.orderId = String(order.id || order.name || '');
      card.open = expandedOrders.indexOf(card.dataset.orderId) !== -1;
      var head = makeElement('summary', 'rwady-account-order__head');
      var identity = makeElement('div');
      identity.appendChild(makeElement('h3', '', valueOrDash(order.name)));
      var time = makeElement('time', '', formatDate(order.processed_at));
      time.dateTime = order.processed_at || '';
      identity.appendChild(time);
      head.appendChild(identity);
      var lineSummary = window.RwadyAccountApi.orderLineSummary(order);
      var snapshotLines = order.line_fulfillment && order.line_fulfillment.lines || [];
      var unavailableCount = snapshotLines.filter(function (line) {
        return line.availability_confirmed === true && line.availability === 'unavailable';
      }).length;
      var partialAvailabilityLabel = isRtl ? 'الطلب متوفر جزئيًا' : 'Order partially available';
      var closedOrder = !order.has_more_items && (order.items || []).length > 0 && (order.items || []).every(function (item) {
        var line = snapshotLines.find(function (entry) { return entry.line_item_id === item.line_item_id; });
        return line && (line.status === 'cancelled' || line.customer_status === 'cancelled' ||
          line.delivered >= item.quantity || (line.availability_confirmed === true && line.availability === 'unavailable'));
      });
      var allProductsUnavailable = !order.has_more_items && (order.items || []).length > 0 &&
        (order.items || []).every(function (item) {
          var line = snapshotLines.find(function (entry) { return entry.line_item_id === item.line_item_id; });
          return line && line.availability_confirmed === true && line.availability === 'unavailable';
        });
      var trackingStatus = allProductsUnavailable ? 'cancelled_unavailable'
        : unavailableCount > 0 ? 'partially_available'
        : closedOrder && snapshotLines.some(function (line) { return line.delivered > 0; }) ? 'completed'
        : lineSummary || orderTrackingStatus(order);
      var statusBadge = makeElement('span', 'rwady-account-order__tracking',
        trackingStatus === 'cancelled_unavailable'
          ? (isRtl ? 'تم إلغاء الطلب لعدم توفر المنتج' : 'Order cancelled because the product was unavailable')
          : trackingStatus === 'partially_available' ? partialAvailabilityLabel
          : trackingStatus === 'completed' ? (isRtl ? 'اكتمل الطلب' : 'Completed')
          : lineSummary ? lineStatusText(lineSummary) : orderTrackingLabel(order));
      statusBadge.dataset.status = trackingStatus;
      head.appendChild(statusBadge);
      card.appendChild(head);
      var recordedLines = order.line_fulfillment && order.line_fulfillment.lines || [];
      var confirmedCount = (order.items || []).filter(function (item) {
        return recordedLines.some(function (line) {
          return line.line_item_id === item.line_item_id && line.availability_confirmed === true &&
            line.availability === 'available' && ['confirmed', 'reserved', 'shipped', 'in_transit', 'delivered',
              'partially_shipped', 'partially_delivered'].indexOf(line.status) !== -1;
        });
      }).length;
      if (!closedOrder && !order.has_more_items && recordedLines.length) identity.appendChild(makeElement('span', 'rwady-account-order__confirmed', isRtl
        ? 'تم تأكيد ' + confirmedCount + ' منتجات من أصل ' + (order.items || []).length
        : confirmedCount + ' of ' + (order.items || []).length + ' products confirmed'));
      var currentProducts = loadCurrentReorderProducts(order);
      if (allProductsUnavailable) currentProducts.then(function (products) {
        if (disposed) return;
        var restocked = (order.items || []).some(function (item) {
          return window.RwadyAccountApi.buildLineReorderPlan(item, products).items.length > 0;
        });
        if (!restocked) return;
        statusBadge.textContent = isRtl
          ? 'تم إلغاء الطلب — توفر المنتج ويمكن إعادة طلبه'
          : 'Order cancelled — product available to reorder';
        statusBadge.dataset.status = 'restocked_cancelled';
      });
      var groups = window.RwadyAccountApi.buildOrderGroups(order);
      groups.forEach(function (group, index) {
        var section = makeElement('section', 'rwady-account-order__group');
        var shipment = group.shipment;
        if (shipment) section.dataset.shipmentId = String(shipment.id);
        var groupUnavailableCount = group.entries.filter(function (entry) {
          return entry.line && entry.line.availability_confirmed === true && entry.line.availability === 'unavailable';
        }).length;
        var groupUnavailableLabel = groupUnavailableCount === 1
          ? (isRtl ? 'منتج غير متوفر' : 'Unavailable product')
          : (isRtl ? 'منتجات غير متوفرة' : 'Unavailable products');
        var heading = shipment
          ? (shipment.number
            ? (isRtl ? 'رقم الشحنة: ' : 'Shipment number: ') + shipment.number
            : (isRtl ? 'شحنة — الرقم لم يُضف بعد' : 'Shipment — number not added yet'))
          : group.kind === 'cancelled_shipment' ? (isRtl ? 'ملغاة بعد الشحن' : 'Cancelled after shipment')
          : groupUnavailableCount > 0 ? groupUnavailableLabel
          : (isRtl ? 'منتجات غير مجهزة' : 'Unprepared products');
        var shipmentHead = makeElement('div', 'rwady-account-order__shipment-head');
        shipmentHead.dataset.status = group.kind === 'cancelled_shipment' ? 'cancelled'
          : groupUnavailableCount > 0 ? 'unavailable' : 'unprepared';
        shipmentHead.appendChild(makeElement('h4', '', heading));
        if (shipment || groupUnavailableCount === 0 || group.kind === 'cancelled_shipment') {
          section.appendChild(shipmentHead);
        }
        if (shipment) {
          shipmentHead.dataset.status = ['ready', 'shipped', 'in_transit', 'delivered', 'cancelled'].indexOf(shipment.customer_status) !== -1
            ? shipment.customer_status : shipment.status;
          shipmentHead.appendChild(makeElement('p', 'rwady-account-order__group-status',
            [lineStatusText(['ready', 'shipped', 'in_transit', 'delivered', 'cancelled'].indexOf(shipment.customer_status) !== -1
              ? shipment.customer_status : shipment.status), shipment.carrier].filter(Boolean).join(' · ')));
          if (group.entries.length > 1) section.appendChild(makeElement('p', 'rwady-account-order__group-note',
            shipment.status === 'reserved'
              ? (isRtl ? 'هذه المنتجات مخصّصة للشحنة نفسها' : 'These products are allocated together')
              : (isRtl ? 'هذه المنتجات مجمّعة ضمن شحنة واحدة، والحالة أعلاه تخصّها معًا.' : 'These products are grouped in one shipment. The status above applies to them together.')));
        }
        var items = makeElement('div', 'rwady-account-order__items');
        group.entries.forEach(function (entry) { items.appendChild(renderOrderItem(entry, currentProducts, shipment, closedOrder, group.kind)); });
        section.appendChild(items);
        card.appendChild(section);
      });
      if (order.has_more_items) card.appendChild(makeElement('p', 'rwady-account-order__status', label('moreItems')));
      var footer = makeElement('div', 'rwady-account-order__footer');
      footer.appendChild(makeElement('span', '', isRtl ? 'إجمالي المنتجات المتوفرة' : 'Available products subtotal'));
      footer.appendChild(makeElement('strong', '', money(availableProductsTotal(order))));
      card.appendChild(footer);
      var shippingFooter = makeElement('div', 'rwady-account-order__footer');
      shippingFooter.appendChild(makeElement('span', '', isRtl ? 'أجرة التوصيل للطلب' : 'Order delivery charge'));
      var deliveryState = orderDelivery(order);
      shippingFooter.appendChild(makeElement('strong', '', money(deliveryState.value)));
      card.appendChild(shippingFooter);
      if (deliveryState.pending) card.appendChild(makeElement('p', 'rwady-account-order__updated', isRtl
        ? 'أجرة التوصيل قيد إعادة الاحتساب؛ المبلغ الظاهر مؤقت.'
        : 'Delivery charge is being recalculated; the displayed amount is provisional.'));
      var subtotal = availableProductsTotal(order);
      var delivery = deliveryState.value;
      var deliveryAmount = delivery && delivery.amount != null && delivery.amount !== '' ? Number(delivery.amount) : NaN;
      var grandTotal = subtotal && delivery && subtotal.currency_code === delivery.currency_code &&
        Number.isFinite(deliveryAmount) && deliveryAmount >= 0
        ? { amount: String((Math.round(Number(subtotal.amount) * 100) + Math.round(deliveryAmount * 100)) / 100), currency_code: subtotal.currency_code }
        : null;
      var rewardUsed = order.loyalty_redemption;
      if (rewardUsed && Number.isSafeInteger(rewardUsed.points) && rewardUsed.points > 0 &&
          Number.isFinite(rewardUsed.value_iqd) && rewardUsed.value_iqd > 0) {
        var rewardFooter = makeElement('p', 'rwady-account-order__reward-used');
        rewardFooter.style.color = '#0641AD';
        rewardFooter.style.fontWeight = '700';
        var pointsText = new Intl.NumberFormat('en-US').format(rewardUsed.points);
        var discountText = new Intl.NumberFormat('en-US').format(rewardUsed.value_iqd);
        rewardFooter.textContent = isRtl
          ? '🎁 تم استخدام ' + pointsText + ' نقطة بخصم قدره ' + discountText + ' د.ع'
          : '🎁 Used ' + pointsText + ' points for a discount of ' + discountText + ' IQD';
        card.appendChild(rewardFooter);
      }
      var totalFooter = makeElement('div', 'rwady-account-order__footer');
      totalFooter.appendChild(makeElement('span', '', isRtl ? 'الإجمالي مع التوصيل' : 'Total including delivery'));
      totalFooter.appendChild(makeElement('strong', '', money(grandTotal)));
      card.appendChild(totalFooter);
      var knownLines = order.line_fulfillment && order.line_fulfillment.lines || [];
      if ((order.items || []).some(function (item) {
        return !knownLines.some(function (line) { return line.line_item_id === item.line_item_id; });
      })) card.appendChild(makeElement('p', 'rwady-account-order__updated', isRtl
        ? 'المجموع يشمل المنتجات المؤكدة متوفرة فقط؛ بعض المنتجات بانتظار تحديث الحالة.'
        : 'Subtotal includes confirmed available products only; some product statuses are pending.'));
      if (order.line_fulfillment && order.line_fulfillment.updated_at) {
        var updated = makeElement('p', 'rwady-account-order__updated',
          (isRtl ? 'آخر تحديث لحالات المنتجات: ' : 'Product statuses updated: ') +
          new Intl.DateTimeFormat(isRtl ? 'ar-IQ' : 'en-IQ', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(order.line_fulfillment.updated_at)));
        card.appendChild(updated);
      }
      list.appendChild(card);
    });
    openNotificationOrder(list);
  }

  function drawAvatarPreview() {
    if (!state.avatarImage) return;
    window.RwadyAvatar.drawSquare(avatarCanvas, state.avatarImage, state.avatarCrop);
  }

  function closeAvatarDialog() {
    if (avatarDialog.open) avatarDialog.close();
    if (state.avatarImage && typeof state.avatarImage.close === 'function') state.avatarImage.close();
    state.avatarImage = null;
    state.avatarFile = null;
    state.avatarCrop = { zoom: 1, offsetX: 0, offsetY: 0 };
    state.avatarPointer = null;
    avatarZoom.value = '1';
    avatarInput.value = '';
  }

  function openAvatarFile(file) {
    try {
      window.RwadyAvatar.validateFile(file);
    } catch (error) {
      setMessage(avatarStatus, avatarErrorText(error));
      avatarInput.value = '';
      return;
    }
    setMessage(avatarStatus, label('avatarLoading'));
    window.RwadyAvatar.decodeImage(file).then(function (image) {
      state.avatarFile = file;
      state.avatarImage = image;
      state.avatarCrop = { zoom: 1, offsetX: 0, offsetY: 0 };
      avatarZoom.value = '1';
      drawAvatarPreview();
      setMessage(avatarStatus, '');
      setMessage(avatarDialogStatus, '');
      avatarDialog.showModal();
    }).catch(function (error) {
      setMessage(avatarStatus, avatarErrorText(error));
      avatarInput.value = '';
    });
  }

  root.querySelectorAll('[data-avatar-select]').forEach(function (button) {
    button.addEventListener('click', function () { avatarInput.click(); });
  });

  avatarInput.addEventListener('change', function () {
    var file = avatarInput.files && avatarInput.files[0];
    if (file) openAvatarFile(file);
  });

  avatarZoom.addEventListener('input', function () {
    state.avatarCrop.zoom = Number(avatarZoom.value) || 1;
    drawAvatarPreview();
  });

  avatarCanvas.addEventListener('pointerdown', function (event) {
    if (!state.avatarImage) return;
    avatarCanvas.setPointerCapture(event.pointerId);
    state.avatarPointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
  });

  avatarCanvas.addEventListener('pointermove', function (event) {
    if (!state.avatarPointer || state.avatarPointer.id !== event.pointerId || !state.avatarImage) return;
    var rect = avatarCanvas.getBoundingClientRect();
    var sourceSize = Math.min(
      Number(state.avatarImage.naturalWidth || state.avatarImage.width),
      Number(state.avatarImage.naturalHeight || state.avatarImage.height)
    );
    var ratio = sourceSize / Math.max(1, rect.width * state.avatarCrop.zoom);
    state.avatarCrop.offsetX -= (event.clientX - state.avatarPointer.x) * ratio;
    state.avatarCrop.offsetY -= (event.clientY - state.avatarPointer.y) * ratio;
    state.avatarPointer.x = event.clientX;
    state.avatarPointer.y = event.clientY;
    drawAvatarPreview();
  });

  function releaseAvatarPointer(event) {
    if (state.avatarPointer && state.avatarPointer.id === event.pointerId) state.avatarPointer = null;
  }
  avatarCanvas.addEventListener('pointerup', releaseAvatarPointer);
  avatarCanvas.addEventListener('pointercancel', releaseAvatarPointer);

  root.querySelectorAll('[data-avatar-crop-cancel]').forEach(function (button) {
    button.addEventListener('click', closeAvatarDialog);
  });

  avatarDialog.addEventListener('cancel', function (event) {
    if (avatarSave.disabled) event.preventDefault();
  });

  avatarSave.addEventListener('click', function () {
    if (!state.avatarFile || avatarSave.disabled) return;
    avatarSave.disabled = true;
    avatarDialog.setAttribute('aria-busy', 'true');
    root.querySelectorAll('[data-avatar-crop-cancel]').forEach(function (button) { button.disabled = true; });
    setMessage(avatarDialogStatus, label('avatarUploading'));
    setMessage(avatarStatus, label('avatarUploading'));
    window.RwadyAvatar.processImage(state.avatarFile, state.avatarCrop).then(function (output) {
      return api.uploadAvatar(output.blob, output.filename).then(function () {
        window.RwadyAvatar.setBlob(output.blob, state.profile);
        closeAvatarDialog();
        setMessage(avatarStatus, label('avatarUpdated'), true);
      });
    }).catch(function (error) {
      if (error && error.status === 401) {
        window.RwadyAvatar.logout();
        handleSessionError(error);
      }
      setMessage(avatarStatus, avatarErrorText(error));
      setMessage(avatarDialogStatus, avatarErrorText(error));
    }).finally(function () {
      avatarSave.disabled = false;
      avatarDialog.setAttribute('aria-busy', 'false');
      root.querySelectorAll('[data-avatar-crop-cancel]').forEach(function (button) { button.disabled = false; });
    });
  });

  root.querySelector('[data-avatar-delete]').addEventListener('click', function () {
    if (!window.confirm(label('avatarDeleteConfirm'))) return;
    var button = root.querySelector('[data-avatar-delete]');
    button.disabled = true;
    setMessage(avatarStatus, label('avatarUploading'));
    api.deleteAvatar().catch(function (error) {
      if (error && error.status === 404) return null;
      throw error;
    }).then(function () {
      window.RwadyAvatar.clearImage(state.profile);
      setMessage(avatarStatus, label('avatarDeleted'), true);
    }).catch(function (error) {
      if (error && error.status === 401) {
        window.RwadyAvatar.logout();
        handleSessionError(error);
      }
      setMessage(avatarStatus, avatarErrorText(error));
    }).finally(function () {
      button.disabled = false;
    });
  });

  function onAccountAvatarUpdated(event) {
    renderAvatar(event.detail || window.RwadyAvatar.snapshot());
  }
  document.addEventListener('rwady:account-avatar-updated', onAccountAvatarUpdated);
  renderAvatar(window.RwadyAvatar.snapshot());

  accountRefresh = window.RwadyAccountApi.createAccountRefreshController({
    refreshInterval: 30000,
    read: function () { return Promise.all([api.profile(), api.addresses(), api.receipts().catch(function () { return { receipts: [] }; })]); },
    onWaiting: function () {
      if (!disposed) {
        delete errorBox.dataset.accountFailureCode;
        show('loading');
      }
    },
    onLinked: function (snapshot) {
      if (disposed) return;
      var renderStage = 'profile';
      try {
        state.profile = snapshot.profile;
        state.addresses = snapshot.addresses;
        renderProfile(state.profile);
        renderStage = 'addresses';
        renderAddresses();
        renderStage = 'orders';
        renderOrders(snapshot.orders);
        renderReceipts(snapshot.receipts, snapshot.orders);
        delete errorBox.dataset.accountFailureCode;
        show('app');
        loadAvatar(state.profile);
      } catch (error) {
        if (!error.code) error.code = 'ACCOUNT_RENDER_' + renderStage.toUpperCase() + '_FAILED';
        throw error;
      }
    },
    onError: function (error) {
      if (disposed) return;
      if (!handleSessionError(error)) {
        var failureCode = String(error && (error.code || error.name) || 'ACCOUNT_LOAD_FAILED').toUpperCase();
        errorBox.dataset.accountFailureCode = /^[A-Z0-9_]+$/.test(failureCode) ? failureCode : 'ACCOUNT_LOAD_FAILED';
        show('error');
      }
    }
  });

  function loadData() {
    return accountRefresh.start();
  }

  function loadAccount() {
    if (accountLoadPromise) return accountLoadPromise;
    show('loading');
    setMessage(authStatus, '');
    accountLoadPromise = api.session().then(function (session) {
      if (disposed) return null;
      if (!session.authenticated) {
        clearAuthenticatedState();
        return null;
      }
      return loadData();
    }).catch(function (error) {
      if (disposed) return null;
      if (!handleSessionError(error)) show('error');
      return null;
    }).finally(function () {
      accountLoadPromise = null;
    });
    return accountLoadPromise;
  }

  root.querySelector('[data-account-retry]').addEventListener('click', loadAccount);
  root.querySelector('[data-account-logout]').addEventListener('click', function () {
    api.logout().catch(function () {}).finally(function () {
      clearAuthenticatedState();
    });
  });

  function selectAccountTab(name, persist) {
    if (disposed) return;
    var tabs = Array.from(root.querySelectorAll('[data-account-tab]'));
    if (!tabs.some(function (tab) { return tab.dataset.accountTab === name; })) return;
    tabs.forEach(function (tab) {
      var active = tab.dataset.accountTab === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });
    root.querySelectorAll('[data-account-panel]').forEach(function (panel) {
      var active = panel.dataset.accountPanel === name;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
    if (persist) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('account_tab', name);
        window.history.replaceState(window.history.state, '', url.href);
      } catch (error) {}
    }
  }

  root.querySelector('.rwady-account-tabs').addEventListener('click', function (event) {
    var button = event.target.closest('[data-account-tab]');
    if (button) selectAccountTab(button.dataset.accountTab, true);
  });

  try {
    selectAccountTab(new URL(window.location.href).searchParams.get('account_tab'), false);
  } catch (error) {}

  function profileNames(fullName) {
    var parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);
    return { first_name: parts.shift() || '', last_name: parts.join(' ') };
  }

  function openProfileDialog() {
    var profile = state.profile || {};
    profileForm.elements.full_name.value = profile.full_name || [profile.first_name, profile.last_name].filter(Boolean).join(' ');
    profileForm.elements.email.value = profile.email || '';
    profileForm.elements.primary_phone.value = profile.primary_phone || '';
    profileForm.elements.alternate_phone.value = profile.alternate_phone || '';
    root.querySelector('[data-delete-alternate-phone]').hidden = !profile.alternate_phone;
    setMessage(profileFormStatus, '');
    if (typeof profileDialog.showModal === 'function') profileDialog.showModal();
    else profileDialog.setAttribute('open', '');
  }

  function closeProfileDialog() {
    if (typeof profileDialog.close === 'function') profileDialog.close();
    else profileDialog.removeAttribute('open');
  }

  root.querySelector('[data-edit-profile]').addEventListener('click', openProfileDialog);
  root.querySelectorAll('[data-close-profile-dialog]').forEach(function (button) {
    button.addEventListener('click', closeProfileDialog);
  });
  profileDialog.addEventListener('click', function (event) {
    if (event.target === profileDialog) closeProfileDialog();
  });

  profileForm.addEventListener('submit', function (event) {
    event.preventDefault();
    var names = profileNames(profileForm.elements.full_name.value);
    var email = String(profileForm.elements.email.value || '').trim().toLowerCase();
    var alternateRaw = String(profileForm.elements.alternate_phone.value || '').trim();
    var alternatePhone = alternateRaw ? window.RwadyAccountApi.normalizePhone(alternateRaw) : '';
    if (!names.first_name || (email && !/^\S+@\S+\.\S+$/.test(email)) || (alternateRaw && !alternatePhone)) {
      setMessage(profileFormStatus, alternateRaw && !alternatePhone ? label('invalidPhone') : label('requiredFields'));
      return;
    }
    var button = root.querySelector('[data-profile-submit]');
    button.disabled = true;
    setMessage(profileFormStatus, '');
    var profileUpdate = { first_name: names.first_name, last_name: names.last_name };
    if (email) profileUpdate.email = email;
    api.updateProfile(profileUpdate).then(function (payload) {
      state.profile = payload.customer || state.profile;
      if (alternatePhone && alternatePhone !== (state.profile.alternate_phone || '')) return api.saveAlternatePhone(alternatePhone);
      return null;
    }).then(function (phonePayload) {
      if (phonePayload) state.profile.alternate_phone = phonePayload.alternate_phone;
      renderProfile(state.profile);
      closeProfileDialog();
      setMessage(profileStatus, label('profileSaved'), true);
    }).catch(function (error) {
      if (!handleSessionError(error)) setMessage(profileFormStatus, errorText(error));
    }).finally(function () { button.disabled = false; });
  });

  root.querySelector('[data-delete-alternate-phone]').addEventListener('click', function (event) {
    if (!window.confirm(label('confirmDeletePhone'))) return;
    event.currentTarget.disabled = true;
    api.deleteAlternatePhone().then(function () {
      state.profile.alternate_phone = null;
      profileForm.elements.alternate_phone.value = '';
      renderProfile(state.profile);
      setMessage(profileFormStatus, label('phoneDeleted'), true);
    }).catch(function (error) {
      if (!handleSessionError(error)) setMessage(profileFormStatus, errorText(error));
    }).finally(function () { event.currentTarget.disabled = false; });
  });

  var provinceCodes = {
    anbar: 'AN', basra: 'BA', muthanna: 'MU', qadisiyah: 'QA', najaf: 'NA', erbil: 'AR', sulaymaniyah: 'SU',
    duhok: 'DA', nineveh: 'NI', kirkuk: 'KI', diyala: 'DI', saladin: 'SD', babylon: 'BB', karbala: 'KA',
    baghdad: 'BG', wasit: 'WA', 'dhi qar': 'DQ', maysan: 'MA', halabja: 'HA',
    'al anbar': 'AN', 'al basrah': 'BA', 'al muthanna': 'MU', 'al qadisiya': 'QA', 'al qadisiyah': 'QA',
    'an najaf': 'NA', arbil: 'AR', 'as sulaymaniyah': 'SU', dahuk: 'DA', ninawa: 'NI',
    'salah ad din': 'SD', babil: 'BB',
    'الأنبار': 'AN', 'الانبار': 'AN', 'البصرة': 'BA', 'المثنى': 'MU', 'القادسية': 'QA', 'النجف': 'NA',
    'أربيل': 'AR', 'اربيل': 'AR', 'السليمانية': 'SU', 'دهوك': 'DA', 'نينوى': 'NI', 'كركوك': 'KI',
    'ديالى': 'DI', 'صلاح الدين': 'SD', 'بابل': 'BB', 'كربلاء': 'KA', 'بغداد': 'BG', 'واسط': 'WA',
    'ذي قار': 'DQ', 'ميسان': 'MA', 'حلبجة': 'HA'
  };

  function provinceValue(value) {
    var raw = String(value || '').trim();
    var normalized = raw.replace(/\b(governorate|province)\b/gi, '').replace(/محافظة/g, '').replace(/\s+/g, ' ').trim();
    return /^[A-Za-z]{2}$/.test(normalized) ? normalized.toUpperCase() : (provinceCodes[normalized] || provinceCodes[normalized.toLowerCase()] || '');
  }

  function openAddressDialog(address) {
    addressForm.reset();
    setMessage(addressFormStatus, '');
    state.createAttempt = null;
    var editing = Boolean(address);
    root.querySelector('[data-address-dialog-title]').textContent = editing ? label('edit') : label('saveAddress');
    root.querySelector('[data-address-submit]').textContent = editing ? label('updateAddress') : label('saveAddress');
    if (editing) {
      ['id', 'label', 'phone', 'secondary_phone', 'address1'].forEach(function (field) {
        addressForm.elements[field].value = address[field] || '';
      });
      addressForm.elements.full_name.value = address.full_name || [address.first_name, address.last_name].filter(Boolean).join(' ');
      addressForm.elements.province.value = provinceValue(address.province_code || address.provinceCode || address.province);
    } else {
      var profile = state.profile || {};
      addressForm.elements.full_name.value = profile.full_name || [profile.first_name, profile.last_name].filter(Boolean).join(' ');
      addressForm.elements.phone.value = profile.primary_phone || '';
      addressForm.elements.secondary_phone.value = profile.alternate_phone || '';
    }
    if (typeof addressDialog.showModal === 'function') addressDialog.showModal();
    else addressDialog.setAttribute('open', '');
  }

  function closeAddressDialog() {
    if (typeof addressDialog.close === 'function') addressDialog.close();
    else addressDialog.removeAttribute('open');
    state.createAttempt = null;
  }

  root.querySelectorAll('[data-close-address-dialog]').forEach(function (button) {
    button.addEventListener('click', closeAddressDialog);
  });
  addressDialog.addEventListener('click', function (event) {
    if (event.target === addressDialog) closeAddressDialog();
  });
  root.querySelector('[data-add-address]').addEventListener('click', function () {
    if (state.addresses.length >= 10) {
      setMessage(addressStatus, label('addressLimit'));
      return;
    }
    openAddressDialog(null);
  });
  root.querySelector('[data-add-default-address]').addEventListener('click', function () {
    root.querySelector('[data-add-address]').click();
  });
  root.querySelector('[data-edit-default-address]').addEventListener('click', function () {
    var address = defaultAddress();
    if (address) openAddressDialog(address);
  });

  root.querySelector('[data-address-list]').addEventListener('click', function (event) {
    var edit = event.target.closest('[data-edit-address]');
    var remove = event.target.closest('[data-delete-address]');
    var setDefault = event.target.closest('[data-default-address]');
    if (edit) {
      openAddressDialog(state.addresses.find(function (address) { return address.id === edit.dataset.editAddress; }));
      return;
    }
    if (remove) {
      if (!window.confirm(label('confirmDeleteAddress'))) return;
      remove.disabled = true;
      api.deleteAddress(remove.dataset.deleteAddress).then(function () {
        setMessage(addressStatus, label('addressDeleted'), true);
        return loadData();
      }).catch(function (error) {
        if (!handleSessionError(error)) setMessage(addressStatus, errorText(error));
      }).finally(function () { remove.disabled = false; });
      return;
    }
    if (setDefault) {
      setDefault.disabled = true;
      api.setDefaultAddress(setDefault.dataset.defaultAddress).then(function () {
        setMessage(addressStatus, label('defaultUpdated'), true);
        return loadData();
      }).catch(function (error) {
        if (!handleSessionError(error)) setMessage(addressStatus, errorText(error));
      }).finally(function () { setDefault.disabled = false; });
    }
  });

  function addressBody() {
    var data = new FormData(addressForm);
    var phone = window.RwadyAccountApi.normalizePhone(data.get('phone'));
    var secondaryPhoneRaw = String(data.get('secondary_phone') || '').trim();
    var secondaryPhone = secondaryPhoneRaw ? window.RwadyAccountApi.normalizePhone(secondaryPhoneRaw) : '';
    var body = {
      label: String(data.get('label') || '').trim(),
      full_name: String(data.get('full_name') || '').trim(),
      phone: phone,
      secondary_phone: secondaryPhone,
      province: String(data.get('province') || '').trim(),
      address1: String(data.get('address1') || '').trim(),
      countryCode: 'IQ'
    };
    var valid = phone && (!secondaryPhoneRaw || secondaryPhone) && body.label && body.full_name && body.province && body.address1;
    return valid ? body : null;
  }

  addressForm.addEventListener('submit', function (event) {
    event.preventDefault();
    var body = addressBody();
    if (!body) {
      setMessage(addressFormStatus, label('requiredFields'));
      return;
    }
    var id = addressForm.elements.id.value;
    var serialized = JSON.stringify(body);
    var button = root.querySelector('[data-address-submit]');
    button.disabled = true;
    setMessage(addressFormStatus, '');
    var operation;
    if (id) operation = api.updateAddress(id, body);
    else {
      if (!state.createAttempt || state.createAttempt.body !== serialized) {
        state.createAttempt = { body: serialized, key: window.RwadyAccountApi.secureIdempotencyKey() };
      }
      operation = api.createAddress(body, state.createAttempt.key);
    }
    operation.then(function (payload) {
      var returnedAddress = payload && payload.address;
      if (!returnedAddress || provinceValue(returnedAddress.province_code || returnedAddress.provinceCode || returnedAddress.province || returnedAddress.city) !== body.province) {
        var persistenceError = new Error('ADDRESS_PROVINCE_NOT_PERSISTED');
        persistenceError.code = 'ADDRESS_PROVINCE_NOT_PERSISTED';
        throw persistenceError;
      }
      var savedId = returnedAddress.id || payload.address_id || id;
      return loadData().then(function () {
        var savedAddress = state.addresses.find(function (address) { return address.id === savedId; });
        if (!savedAddress || provinceValue(savedAddress.province_code || savedAddress.provinceCode || savedAddress.province || savedAddress.city) !== body.province) {
          var persistenceError = new Error('ADDRESS_PROVINCE_NOT_PERSISTED');
          persistenceError.code = 'ADDRESS_PROVINCE_NOT_PERSISTED';
          throw persistenceError;
        }
      });
    }).then(function () {
      var message = id ? label('addressUpdated') : label('addressSaved');
      closeAddressDialog();
      setMessage(addressStatus, message, true);
    }).catch(function (error) {
      if (!handleSessionError(error)) setMessage(addressFormStatus, errorText(error));
    }).finally(function () { button.disabled = false; });
  });

  loadAccount();

  function disposeAccount() {
    if (disposed) return;
    disposed = true;
    if (accountRefresh) accountRefresh.stop();
    window.clearTimeout(state.receiptRefreshTimer);
    state.receiptRefreshTimer = 0;
    state.receiptRefreshAttempts = 0;
    state.receiptRefreshEpoch += 1;
    document.removeEventListener('rwady:account-avatar-updated', onAccountAvatarUpdated);
    clearInterval(state.resendTimer);
    state.resendTimer = 0;
    if (state.avatarImage && typeof state.avatarImage.close === 'function') state.avatarImage.close();
    state.avatarImage = null;
    state.avatarFile = null;
    state.avatarPointer = null;
    if (avatarDialog && avatarDialog.open) closeAvatarDialog();
    if (profileDialog && profileDialog.open) closeProfileDialog();
    if (addressDialog && addressDialog.open) closeAddressDialog();
    if (deletionDialog && deletionDialog.open) {
      state.deletionBusy = false;
      closeDeletionDialog();
    }
    root.removeAttribute('data-initialized');
  }

  return { root: root, dispose: disposeAccount };
  }

  function accountRootWithin(scope) {
    if (!scope) return null;
    if (scope.matches && scope.matches('[data-rwady-account]')) return scope;
    return scope.querySelector ? scope.querySelector('[data-rwady-account]') : null;
  }

  function activateAccount(scope) {
    var root = accountRootWithin(scope);
    if (!root) return;
    if (activeController) activeController.dispose();
    activeController = initializeAccount(root);
  }

  function onAccountSectionLoad(event) {
    activateAccount(event.target);
  }

  function onAccountSectionUnload(event) {
    if (!activeController) return;
    var target = event.target;
    if (target === activeController.root || (target && target.contains && target.contains(activeController.root))) {
      activeController.dispose();
      activeController = null;
    }
  }

  function destroyAccountLifecycle() {
    document.removeEventListener('shopify:section:load', onAccountSectionLoad);
    document.removeEventListener('shopify:section:unload', onAccountSectionUnload);
    window.removeEventListener('pagehide', destroyAccountLifecycle);
    if (activeController) activeController.dispose();
    activeController = null;
    if (window[lifecycleKey] && window[lifecycleKey].destroy === destroyAccountLifecycle) delete window[lifecycleKey];
  }

  document.addEventListener('shopify:section:load', onAccountSectionLoad);
  document.addEventListener('shopify:section:unload', onAccountSectionUnload);
  window.addEventListener('pagehide', destroyAccountLifecycle);
  window[lifecycleKey] = { destroy: destroyAccountLifecycle };
  activateAccount(document);
}());



